// libs
import React, {Fragment, useState} from 'react';
// components
import PrintErrorMsg from '../../components/print-error-msg';
// config & functions 
// ...

function Table({loadapidata, offset, list, orgInfo, token, paginationNo}) {
    console.log('list', list)
    if(list && Array.isArray(list) && list.length > 0) {
        const pNo = paginationNo ? paginationNo : 1;
        return <>
            <div className="table-responsive">
                <table className="table fs-14rem">
                    <thead>
                        <tr>
                            <th style={{minWidth: '100px'}}>Name</th>
                            <th style={{minWidth: '200px'}}>Email</th>
                            <th style={{minWidth: '250px'}}>Phone</th>
                        </tr>
                    </thead>
                    <tbody>
                        {list.map((data,i) => {
                            return <tr key={Math.random()}>
                                <td>{data.name}</td>
                                <td>{data.email}</td>
                                <td>{data.phoneNo}</td>
                            </tr>
                        })}
                    </tbody>
                </table>
            </div>
        </>
    } else {
        return <PrintErrorMsg msg={'No order items available'} />;
    }
}

export default Table;